import { FC } from 'react';

import lang from '../../lib/language';

import iconGroup from '../../assets/img/Group.svg';
import NoDataIcon from '../../assets/img/icon-no-data.svg';

import styles from './NoDataAvailable.module.scss';

type NoDataProps = { title?: string, isNoDataIcon?: boolean, className?: string}

const NoDataAvailable: FC<NoDataProps> = (props: NoDataProps): JSX.Element => {
  const { title, isNoDataIcon, className } = props;

  return (
    <div className={className || styles.wrapperNoData}>
      <img src={isNoDataIcon ? NoDataIcon : iconGroup} alt="icon group" />
      <p>{title || lang.commonMessageNoData()}</p>
    </div>
  );
};

export default NoDataAvailable;
